import UserService from "@/service/UserService.ts";
import { SigninModel, SignupModel, ProfileInfo } from "@/model/system";
import { UserState } from "./state";
export default {
  state: new UserState(),
  getters: {
    profile(state: UserState): ProfileInfo {
      return state.profile;
    },
  },
  mutations: {
    setProfile(state: UserState, profile: ProfileInfo) {
      state.profile = profile;
    },
  },
  actions: {
    reload({ commit, state }: { commit: any; state: UserState }) {
      return UserService.getTicketInfo({}).then(function(json) {
        if (json.isSucc && json.result) {
          commit("setProfile", json.result);
        }
        return json;
      });
      // return UserService.getProfileInfo().then(function(json) {
      //     if (json.isSucc && json.result) {
      //         commit("setProfile", json.result);
      //     }
      //     return json;
      // });
    },
    signIn({ commit, state }: { commit: any; state: UserState }, signinModel: SigninModel) {
      return UserService.signIn(signinModel).then(function(json) {
        if (json.isSucc && json.result) commit("setProfile", json.result);
        return json;
      });
    },
    signUp({ commit, state }: { commit: any; state: UserState }, signupModel: SignupModel) {
      return UserService.signUp(signupModel).then(function(json) {
        commit("setProfile", json.result);
        return json;
      });
    },
    signOut({ commit, state }: { commit: any; state: UserState }) {
      return UserService.signOut().then(function(json) {
        if (json.isSucc) {
          commit("setProfile", null);
        }
        return json;
      });
    },
  },
};
